var readMore = document.getElementById('read-more');
var readLess = document.getElementById('read-less');

var collapsedContent = document.getElementById('collapsed-content');
var hiddenContent = document.getElementById('full-content');

if (readMore != null) {
	readMore.addEventListener('click', () => {
		collapsedContent.classList.add('hidden');
		hiddenContent.classList.remove('hidden');
	})
}
if (readLess != null) {
	readLess.addEventListener('click', () => {
		hiddenContent.classList.add('hidden');
		collapsedContent.classList.remove('hidden');
	})
}
